import { Component, OnInit } from '@angular/core';
import { Contendiente } from 'src/app/interfaces/contendiente.interface';
import { ContendientesService } from 'src/app/services/contendientes.service';
import copy from 'fast-copy';

@Component({
  selector: 'app-funciones',
  templateUrl: './funciones.component.html',
  styleUrls: ['./funciones.component.css']
})
export class FuncionesComponent implements OnInit {
  title = 'Diputados Contendientes 2021';
  idioma = 'es';
  loading: boolean = false;
  contendientes: Contendiente[] = [];
  contendiente: any;
  fullTextString: any;
  keyWord: any;
  loadingPosts: boolean = true;
  files: any;
  catalog: any;
  error: any;
  termino: string = '';

  constructor(private api: ContendientesService) { }

  ngOnInit(): void {
    this.loading = true;
    this.api.getContendientes(false).subscribe((data) => {
      this.contendientes = data;
      // console.log('this.contendientes');
      // console.log(this.contendientes);
this.contendientes=this.contendientes.filter((obj)=>{
return obj.EnFunciones==='En funciones'
});


      this.contendientes.forEach((element: Contendiente) => {
        const myData = copy(element);
        myData.Tipo = myData.NombreArchivo
          ? myData.NombreArchivo.split('.')[1]
          : myData.NombreArchivo;
        element = myData;
        // console.log('element');
        // console.log(element);
      });
      this.loading = false;
    });
  }
  searchPosts() {
    const keyWordFilter = this.fullTextString ? null : this.keyWord;
    this.loadingPosts = true;
    this.api
      .searchPosts(keyWordFilter, this.fullTextString, this.files, this.catalog)
      .refetch()
      .then((result) => {
        this.loadingPosts = false;
        this.contendientes = result.data && result.data.filterContendientes23;
        this.contendientes.forEach((element: Contendiente) => {
          const myData = copy(element);
          myData.Tipo = myData.NombreArchivo
            ? myData.NombreArchivo.split('.')[1]
            : myData.NombreArchivo;
          element = myData;
          // console.log('element');
          // console.log(element);
        });
        this.loading = result.loading;
        this.error = result['error'];
      });
  }

  downloadBase64File(objeto: Contendiente) {
    // console.log('Contendiente:');
    // console.log(objeto);
    this.api.getContendiente(false, objeto.Oid).subscribe((data) => {
      // console.log('data:');
      // console.log(data);
      this.contendiente = null;
      if (data[0] !== undefined) {
        this.contendiente = data[0];
        const myData = copy(this.contendiente);
        myData.Tipo = myData.NombreArchivo
          ? myData.NombreArchivo.split('.')[1]
          : myData.NombreArchivo;
        this.contendiente = myData;
        let base64: any = null;
        let fileName: any = null;
        let fileType: any = null;
        if (this.contendiente) {
          base64 = this.contendiente.ArchivoB64;
          fileName = this.contendiente.NombreArchivo;
          // console.log('fileName');
          // console.log(fileName);
          fileType = this.contendiente.Tipo;
          // console.log('fileType');
          // console.log(fileType);
        }

        const linkSource = `data:application/${fileType};base64,${base64}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        downloadLink.remove();
      }
      this.loading = false;
    });
  }
}

